import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'

const EGNYTE_HOW_IT_WORKS_BASE = [
  'Link an Egnyte folder to any client in Zocks',
  'Save generated PDFs - meeting summaries, meeting prep, forms - straight to Egnyte',
  'Keep client documents organized across both platforms',
  'Browse and upload files from Egnyte directly in Zocks',
]

const EGNYTE_HOW_IT_WORKS_ULTIMATE = [
  'Pull documents from Egnyte into Zocks for processing - no manual uploads needed',
  'Save document summaries to Egnyte',
  'Work from your existing Egnyte library without leaving the platform',
]

export const EgnyteHowItWorks: React.FC = () => {
  const { hasQuota } = useZocksQuota()
  const documentIntelligenceEnabled = hasQuota('ai.documentSummaryAgent.value')
  const lines = documentIntelligenceEnabled ? [...EGNYTE_HOW_IT_WORKS_BASE, ...EGNYTE_HOW_IT_WORKS_ULTIMATE] : EGNYTE_HOW_IT_WORKS_BASE

  return (
    <div>
      <ul>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
